/* Shared phone-number check for the funnel and questionnaire forms. */
export const PHONE_MAX = 30
export function validPhone(value: unknown): value is string {
  if (typeof value !== 'string') return false
  const v = value.trim()
  if (!v || v.length > PHONE_MAX || !/^\+?[\d\s().-]+$/.test(v)) return false
  const digits = v.replace(/\D/g, '').length
  return digits >= 7 && digits <= 15
}
